import React, { useEffect, useState } from "react";
import Compose from "./Compose";
import Header from "./Header";
import Messages, { MessageType } from "./Messages";
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
//@ts-ignore
import styles from "../Conversation/conversation.module.css";
import Image from "next/image";
export interface WidgetConfig {
    waId: string;
    siteName: string;
    siteTag: string;
    siteLogo: string;
    widgetPosition: "LEFT" | "RIGHT";
    triggerMessage: string;
    welcomeMessage: string;
    brandColor?: string;
    buttonText?: string;
    messageText?: string;
    replyOptions?: string[];
    widgetStyle: string;
    customQuestion?: string;
    startChatBtnTxt?: string;
    widgetPositionMarginX: number;
    widgetPositionMarginY: number;
}

const ConversationContainer: React.FC<{ data?: WidgetConfig }> = ({ data }) => {
    if (!data) {
        return null;
    }
    const { siteName: title, siteLogo: logo, siteTag: status, welcomeMessage, messageText, replyOptions, widgetStyle, startChatBtnTxt, customQuestion } = data;
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const [msgs, setMsgs] = useState<MessageType[]>([{ text: welcomeMessage }]);
    // eslint-disable-next-line react-hooks/rules-of-hooks
    useEffect(() => {
        const baseMessage = { text: welcomeMessage };

        if (widgetStyle === "v1" && messageText) {
            setMsgs([baseMessage, { text: messageText, replyOptions }]);
        } else if (customQuestion) {
            setMsgs([baseMessage, { text: customQuestion }]);
        }
    }, [welcomeMessage, messageText, replyOptions, customQuestion, widgetStyle]);

    return (
        <>
            {widgetStyle === "v1" ? (
                <div className="relative grid justify-center m-auto lg:w-96 w-80 max-h-full rounded-lg shadow-md bg-white overflow-hidden">
                    <Header title={title} status={status} logo={logo} />
                    <div className={styles.messagescontainer}>
                        <Messages msgs={msgs} />
                        <div className="absolute bottom-0 w-full">
                            <Compose />
                            <div className="flex items-center justify-center mt-2 mb-3">
                                <span className="text-xs text-gray-600 mx-2 font-bold">Powered by </span>
                                <Image width={60} height={2} src="/gallabox-logo.svg" alt="Gallabox logo" />
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className="relative grid justify-center m-auto lg:w-96 w-80  rounded-lg shadow-md bg-white overflow-hidden">
                    <Header title={title} status={status} logo={logo} />
                    <div className={`${styles.messagescontainerv2} `}>
                        <div className="h-56 overflow-y-auto">
                            <div className={`${styles.messagebubble} mb-3`}>
                                <div className={styles.triright}>
                                    <div className={styles.messagetext}>
                                        <p>{welcomeMessage}</p>
                                    </div>
                                </div>
                            </div>
                            <div className={styles.messagebubblev2}>
                                <div className={styles.trirightv2}>
                                    <div className={styles.messagetextv2}>
                                        <p>{customQuestion}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="absolute bottom-0 w-full bg-white">
                            <p className="h-11 text-base rounded-full mt-4 mx-4 pl-5 pr-5 shadow flex flex-grow pt-2.5 text-white justify-center bg-green-500  bg-[#25D466]">
                                {startChatBtnTxt}
                            </p>
                            <div className="flex items-center mt-2 mb-4 justify-center">
                                <span className="text-xs text-gray-600 mx-2 font-bold">Powered by </span>
                                <Image width={60} height={2} src="/gallabox-logo.svg" alt="Gallabox logo" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default ConversationContainer;
